<template>
    <div class="flex gap-2 justify-between">
        <div class="bg-v2-white border border-v2-gray-70 flex items-center rounded-md w-full gap-1 pl-3 dark:bg-v2-gray-30 dark:border-v2-gray-10 dark:focus-within:border-v2-gray-80">
            <BaseSvg name="SearchThick" aria-hidden="true" />
            <input
                type="text"
                autocomplete="off"
                aria-autocomplete="off"
                data-dialog-focus="true"
                v-model="searchTerm"
                ref="searchInput"
                :placeholder="$t('Search by keyword, product or manufacturer')"
                class="text-base font-bold w-full bg-transparent border-none focus:ring-0 placeholder:font-normal pl-[.25em]"
                @keyup.enter="$emit('search', searchTerm)"
            />
        </div>
        <div class="flex items-center justify-center shrink-0 w-10">
            <LoadingSpinner v-if="showSkeleton" />
            <button 
                v-else 
                @click="handleButtonClick" 
                class="flex group items-center justify-center p-2 rounded-full scale-95 size-10 hover:bg-gray-tier-6 active:bg-gray-tier-2"
            >
                <BaseSvg 
                    :name="searchTerm === '' ? 'icon-close-thick' : 'icon-refresh-thick'"
                    class="fill-tertiary group-hover:fill-default"
                    aria-hidden="true"
                />
                <span class="sr-only" v-if="searchTerm === ''">Cancel</span>
                <span class="sr-only" v-else>Refresh</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { BaseSvg, LoadingSpinner } from "@/Components";

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
    showSkeleton: {
        type: Boolean,
        default: false
    },
    showResults: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'close', 'clear', 'search']);

const searchInput = ref(null);

const searchTerm = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});

const handleButtonClick = () => {
    if (searchTerm.value === '') {
        emit('close');
    } else {
        searchTerm.value = '';
        emit('clear');
    }
};

watch(() => props.modelValue, (newValue) => {
    if (newValue === '') {
        searchInput.value?.focus();
    }
});

defineExpose({
    focus: () => searchInput.value?.focus()
});
</script>